import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
  warmUp: "",
  coolDown: "",
  notes: "",
  sessionNotes: "",
  isRowAdd: null,
  isRowRemove: null,
  isLinkRow: null,
  isUnlinkRow: null,
  showLeavePopUp: false,
  weeks: null,
  showLinkButton: false,
  showUnlinkButton: false,
  selectedRowCount: 0,
  clearSelectionTrigger: 0,
};

export const blankSessionSlice = createSlice({
  name: "blankSession",
  initialState,
  reducers: {
    setProgramName: (state, action) => {
      state.name = action.payload;
    },
    addWarmUp: (state, action) => {
      state.warmUp = action.payload;
    },
    addCoolDown: (state, action) => {
      state.coolDown = action.payload;
    },
    addNotes: (state, action) => {
      state.notes = action.payload;
    },
    addSessionNotes: (state, action) => {
      state.sessionNotes = action.payload;
    },
    setAddRow: (state, action) => {
      state.isRowAdd = action.payload;
    },
    setRemoveRow: (state, action) => {
      state.isRowRemove = action.payload;
    },
    setLinkRow: (state, action) => {
      state.isLinkRow = action.payload;
    },
    setUnlinkRow: (state, action) => {
      state.isUnlinkRow = action.payload;
    },
    setShowLeavePopUp: (state) => {
      state.showLeavePopUp = !state.showLeavePopUp;
    },
    setWeekData: (state, action) => {
      state.weeks = action.payload.map((row) => ({
        ...row,
      }));
    },
    setShowLinkButton: (state, action) => {
      state.showLinkButton = action.payload;
    },
    setShowUnlinkButton: (state, action) => {
      state.showUnlinkButton = action.payload;
    },
    setSelectedRowCount: (state, action) => {
      state.selectedRowCount = action.payload;
    },
    triggerClearSelection: (state) => {
      state.clearSelectionTrigger += 1;
      state.selectedRowCount = 0;
    },
    resetBlankSession: () => initialState,
  },
});

export const {
  setProgramName,
  addWarmUp,
  addCoolDown,
  addNotes,
  addSessionNotes,
  setAddRow,
  setRemoveRow,
  setLinkRow,
  setUnlinkRow,
  setShowLeavePopUp,
  setWeekData,
  setShowLinkButton,
  setShowUnlinkButton,
  setSelectedRowCount,
  triggerClearSelection,
  resetBlankSession,
} = blankSessionSlice.actions;

export default blankSessionSlice.reducer;
